module.exports = __webpack_public_path__ + "img/icon-empty-new.a49aa28e.png";